const doc = [({"da":({"js":({"routes":({"admin":({"users":({"dialogues":({"new_dialogue_for_user":"Ny dialog for bruger"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;